import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { SessionService } from '@shared/services/session.service';
import { from, Observable, of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';

/** Does not allow route to activate until session is loaded */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  public authObservable = this.session.session.pipe(
    map(() => true),
    catchError((e) => {
      console.error(e);

      return of(false);
    }),
    first()
  );

  constructor(private readonly session: SessionService) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authObservable;
  }
}
